import React from "react";
import CandlelitHero from "./CandlelitHero";
import { BrandMark, ClockIcon, Marigold, PinIcon, TicketIcon } from "../art/Icons";
import RegistrationSection from "../registration/RegistrationSection";
import { EVENT } from "../../config/event";
import { useRegistrationClock } from "../../hooks/useRegistrationClock";

const HomePage = () => {
  const { isOpen, timeLeft } = useRegistrationClock();

  return (
    <>
      <CandlelitHero isOpen={isOpen} />

      <div className="facts">
        <div className="fact">
          <ClockIcon />
          <div>
            <div className="lbl">Kdy</div>
            <div className="val">
              {EVENT.date}
              <span>{EVENT.time}</span>
            </div>
          </div>
        </div>
        <div className="fact">
          <PinIcon />
          <div>
            <div className="lbl">Kde</div>
            <div className="val">
              {EVENT.faculty}
              <span>
                {EVENT.university} · {EVENT.address}
              </span>
            </div>
          </div>
        </div>
        <div className="fact">
          <TicketIcon />
          <div>
            <div className="lbl">Vstup</div>
            <div className="val">
              {EVENT.admission}
              <span>{EVENT.admissionNote}</span>
            </div>
          </div>
        </div>
      </div>

      <section className="intro" id="story" aria-labelledby="story-heading">
        <div className="folk-divider" aria-hidden="true"><span /><Marigold /><BrandMark /><Marigold /><span /></div>
        <span className="kicker">Za světlem svíček. Za hranice všedního dne.</span>
        <h2 id="story-heading">Dokážeš se vrátit<br />do světa živých?</h2>
        <p className="lead">
          Projdi branou z cempasúchilů do <b>Země vzpomínek</b>, kterou tě provede sama La Muerte – paní svátku mrtvých.
          Splň úkoly. Seber razítka. Odhal heslo. A najdi svou cestu zpátky.
        </p>
        <div className="story-steps" aria-label="Tvá cesta">
          <span><b>01</b> Projdi branou</span><i aria-hidden="true">✦</i>
          <span><b>02</b> Odhal tajemství</span><i aria-hidden="true">✦</i>
          <span><b>03</b> Vrať se mezi živé</span>
        </div>
      </section>

      <div className="invoke">
        <Marigold className="invoke-flower" />
        <p>Zapalte svíčku. Položte cempasúchil. Vyslovte její jméno.</p>
        <h2><span>La Muerte,</span> <span>La Muerte,</span> <span>La Muerte…</span></h2>
        <span className="invoke-note">Odvážíte se ji vyvolat?</span>
        <Marigold className="invoke-flower" />
      </div>

      <RegistrationSection isOpen={isOpen} timeLeft={timeLeft} />
    </>
  );
};

export default HomePage;
